import * as React from 'react';
import { Link } from 'react-router-dom';

import { objectInspectorPath } from '../../paths';

export interface IInspectLinkProps {
  id: string;
  /** Show the first 8 characters, the whole id on hover, where a table column is too narrow for a UUID. */
  short?: boolean;
  /** Rendered in place of the id itself — e.g. the id with its search hits marked. Ignores `short`. */
  children?: React.ReactNode;
}

/** An id linked to the object inspector, which opens on it. */
const InspectLink = ({ id, short = false, children }: IInspectLinkProps) => (
  <Link
    to={objectInspectorPath(id)}
    title={short ? `${id} · open in the object inspector` : 'Open in the object inspector'}
    className="text-fg-brand-primary hover:text-fg-brand-secondary font-mono underline-offset-2 hover:underline"
  >
    {children ?? (short ? id.slice(0, 8) : id)}
  </Link>
);

export default InspectLink;
